import { FC } from "react";
import { Grid, styled } from "@mui/material";
import { TCompanyFilterForm } from "@/features/company/types";
import { TOption } from "@/types/common";
import { CompanyFilterForm } from "@/features/company/components/company-list/CompanyFilterForm";
import Divider from "@mui/material/Divider";

type Props = {
  formValues: TCompanyFilterForm;
  onChangeFormValues: (filters: TCompanyFilterForm) => void;
  onSubmit: (filters: TCompanyFilterForm) => void;
  industryOptions: TOption[];
  isIndustryLoading: boolean;
};

export const CompanyListTop: FC<Props> = ({
  formValues,
  onChangeFormValues,
  onSubmit,
  industryOptions,
  isIndustryLoading,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CompanyFilterForm
          formValues={formValues}
          onChange={onChangeFormValues}
          onSubmit={() => onSubmit(formValues)}
          industryOptions={industryOptions}
          isIndustryLoading={isIndustryLoading}
        />
      </Grid>

      <Grid item xs={12}>
        <ListCompanyDivider />
      </Grid>
    </Grid>
  );
};

const ListCompanyDivider = styled(Divider)`
  width: 100%;
`;
